"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const l=require("./hooks/use-yield-callback.cjs"),e=require("./utils/yield-callback.cjs");exports.useYieldCallback=l.useYieldCallback;exports.yieldCallback=e.yieldCallback;
//# sourceMappingURL=index.cjs.map
